import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction, serviceCall } from '../../serviceCall'

export const getSubscriptionTransactionList = (data, callback, errorCallBack) => {

    return async (dispatch) => {

        formDataCommonFunction(data, apiConstants.PAYMENT_GATEWAY.GET_SUBSCRIPTION_TRANSACTION_LIST)
            .then((response) => {
                callback && callback(response)

            })
            .catch((error) => {
                errorCallBack && errorCallBack(error.response)
            })
    }
} 